const styles = {
  item: {
    transition: 'all .2s linear',
    background: '#f1f7ed',
    color: '#523c40',
    width: '60px',
    height: '50px',
    textAlign: 'center',
    lineHeight: '50px',
    display: 'inline-block',
    cursor: 'pointer',
  },
  selected: {
    background: '#3f0920',
    color: '#eff5ea',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMenu/PlayerMenuItem/PlayerMenuItem.styles.js